module.exports = __webpack_public_path__ + "img/csm__MG_8897_5e79ca3093.1e789408.jpg";